// Auth layout subtitle strings (auto-merged by lib/i18n.ts).
export const en = {
  'auth.subtitle.portal': 'Customer portal',
  'auth.subtitle.operator': 'Operator console',
  'auth.subtitle.operator_invite_only': 'Operator console · Internal use only',
  'auth.brand.headline': 'Freight, in full view.',
  'auth.brand.sub':
    'Quotes, shipments, documents and tracking — one platform for your whole logistics operation.',
  'auth.back_to_login': 'Back to sign in',
  'auth.forgot_password.link': 'Forgot password?',
  'auth.forgot_password.head': 'Reset your password',
  'auth.forgot_password.title': 'Forgot your password?',
  'auth.forgot_password.lead': "Enter your email and we'll send you a link to reset it.",
  'auth.forgot_password.email': 'Email',
  'auth.forgot_password.submit': 'Send reset link',
  'auth.reset_password.head': 'Choose a new password',
  'auth.reset_password.title': 'Choose a new password',
  'auth.reset_password.lead': 'Enter a new password for your account.',
  'auth.reset_password.password': 'New password',
  'auth.reset_password.confirm': 'Confirm new password',
  'auth.reset_password.submit': 'Update password',
  'auth.reset_password.mismatch': "Passwords don't match.",
  'auth.reset_password.invalid_title': 'This link is invalid or expired',
  'auth.reset_password.invalid_body':
    'Password-reset links are valid for one hour and can be used once. Please request a new one.',
}

export const zhTW = {
  'auth.subtitle.portal': '客戶入口',
  'auth.subtitle.operator': '營運主控台',
  'auth.subtitle.operator_invite_only': '營運主控台 · 僅供內部使用',
  'auth.brand.headline': '貨運，盡收眼底。',
  'auth.brand.sub': '報價、貨件、文件與追蹤 — 一個平台管理您的整體物流營運。',
  'auth.back_to_login': '返回登入',
  'auth.forgot_password.link': '忘記密碼？',
  'auth.forgot_password.head': '重設您的密碼',
  'auth.forgot_password.title': '忘記密碼了嗎？',
  'auth.forgot_password.lead': '輸入您的電子郵件，我們將寄送重設連結給您。',
  'auth.forgot_password.email': '電子郵件',
  'auth.forgot_password.submit': '寄送重設連結',
  'auth.reset_password.head': '設定新密碼',
  'auth.reset_password.title': '設定新密碼',
  'auth.reset_password.lead': '請為您的帳號輸入新密碼。',
  'auth.reset_password.password': '新密碼',
  'auth.reset_password.confirm': '確認新密碼',
  'auth.reset_password.submit': '更新密碼',
  'auth.reset_password.mismatch': '兩次輸入的密碼不相符。',
  'auth.reset_password.invalid_title': '此連結無效或已過期',
  'auth.reset_password.invalid_body': '密碼重設連結 1 小時內有效且僅能使用一次。請重新申請。',
}
